import { GridPanel } from '@/components/grid-panel';
import { Page } from '@/components/page';
import { Toggle } from '@/components/toggle';
import { useState } from 'react';
import GridLayout, { WidthProvider } from 'react-grid-layout';
import { TreeStoreProvider } from '@/context/tree-context';
import { ExploreWidget } from '@/components/explore-widget';
import { CustomAppWidget } from '@/components/custom-app-widget';
import { useTabId } from '@/hooks/use-tab-id';
import { useScreenId } from '@/hooks/use-screen-id';
import { EditWidget } from '@/components/edit-widget';

const layout = [
  { i: 'main_1', x: 0, y: 0, w: 25, h: 15 },
  { i: 'sidebar', x: 25, y: 0, w: 15, h: 15 },
  { i: 'main_2', x: 0, y: 1, w: 40, h: 15 },
];

const AutoWidthGridLayout = WidthProvider(GridLayout);

export function CustomWidget() {
  const [isDraggable, setIsDraggable] = useState<boolean>(false);
  const tabId = useTabId();
  const screenId = useScreenId();
  const idPrefix = `${tabId}/${screenId}`;

  if (!tabId || !screenId) {
    return null;
  }

  return (
    <Page
      title="Libelle Onlineshop"
      toolbar={
        <Toggle
          enabled={isDraggable}
          label="Enable drag"
          onChange={setIsDraggable}
        />
      }
    >
      <AutoWidthGridLayout
        className="layout"
        layout={layout}
        cols={40}
        rowHeight={30}
        isDraggable={isDraggable}
      >
        <GridPanel key="main_1">
          <TreeStoreProvider name="custom-app">
            <ExploreWidget
              id={`${idPrefix}/explorer`}
              defaultViewMode="table"
              defaultEsQueries={[
                {
                  container: 'a8309ad3-645a-4690-b7c3-18bf2aa5bd44',
                  query:
                    '{"bool":{"must":[{"term":{"dataClassUuid.keyword":"d75e5c71-74ef-4588-83b8-082a730d7f29"}}]}}',
                },
              ]}
            />
          </TreeStoreProvider>
        </GridPanel>
        <GridPanel key="sidebar">
          <EditWidget id={`${idPrefix}/edit`} />
        </GridPanel>
        <GridPanel key="main_2">
          <CustomAppWidget />
        </GridPanel>
      </AutoWidthGridLayout>
    </Page>
  );
}
